/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
  WorkplaceListApiV1CollaborationAppWorkplaceGetQueryParams,
  WorkplaceListApiV1CollaborationAppWorkplaceGetHeaderParams,
  WorkplaceListApiV1CollaborationAppWorkplaceGet422,
} from '../../types/WorkplaceListApiV1CollaborationAppWorkplaceGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const workplaceListApiV1CollaborationAppWorkplaceGetQueryKey = (params?: WorkplaceListApiV1CollaborationAppWorkplaceGetQueryParams) =>
  [{ url: '/api/v1/collaboration_app/workplace' }, ...(params ? [params] : [])] as const

export type WorkplaceListApiV1CollaborationAppWorkplaceGetQueryKey = ReturnType<typeof workplaceListApiV1CollaborationAppWorkplaceGetQueryKey>

/**
 * @summary Workplace List
 * {@link /api/v1/collaboration_app/workplace}
 */
export async function workplaceListApiV1CollaborationAppWorkplaceGet(
  params?: WorkplaceListApiV1CollaborationAppWorkplaceGetQueryParams,
  headers?: WorkplaceListApiV1CollaborationAppWorkplaceGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
    ResponseErrorConfig<WorkplaceListApiV1CollaborationAppWorkplaceGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/collaboration_app/workplace`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function workplaceListApiV1CollaborationAppWorkplaceGetQueryOptions(
  params?: WorkplaceListApiV1CollaborationAppWorkplaceGetQueryParams,
  headers?: WorkplaceListApiV1CollaborationAppWorkplaceGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = workplaceListApiV1CollaborationAppWorkplaceGetQueryKey(params)
  return queryOptions<
    WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
    ResponseErrorConfig<WorkplaceListApiV1CollaborationAppWorkplaceGet422>,
    WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return workplaceListApiV1CollaborationAppWorkplaceGet(params, headers, config)
    },
  })
}

/**
 * @summary Workplace List
 * {@link /api/v1/collaboration_app/workplace}
 */
export function useWorkplaceListApiV1CollaborationAppWorkplaceGet<
  TData = WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
  TQueryData = WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
  TQueryKey extends QueryKey = WorkplaceListApiV1CollaborationAppWorkplaceGetQueryKey,
>(
  params?: WorkplaceListApiV1CollaborationAppWorkplaceGetQueryParams,
  headers?: WorkplaceListApiV1CollaborationAppWorkplaceGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        WorkplaceListApiV1CollaborationAppWorkplaceGetQueryResponse,
        ResponseErrorConfig<WorkplaceListApiV1CollaborationAppWorkplaceGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? workplaceListApiV1CollaborationAppWorkplaceGetQueryKey(params)

  const query = useQuery(
    {
      ...workplaceListApiV1CollaborationAppWorkplaceGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<WorkplaceListApiV1CollaborationAppWorkplaceGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}